var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section-main',[_c('section-title',{attrs:{"title":"projekty"}}),_vm._v(" "),_c('div',{staticClass:"projects"},[_vm._l((_vm.projects),function(project,i){return _c('project-tile',{key:i,attrs:{"title":project.name,"logo":project.logo,"scopes":project.scope,"is-active-tile":_vm.isActive(i)},on:{"click":function($event){_vm.handleToggle(i)}}})}),_vm._v(" "),_c('project-tile',{attrs:{"scopes":"miejsce na Twój projekt"}})],2)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14153deb","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Projects.vue
// module id = null
// module chunks = 